<template>
    <isc-button
        class="button-xlarge"
        :disabled="disabled"
        :loading="loading"
        :type="type"
        :icon="icon"
        :plain="plain"
        :style="{ width }"
        v-on="$listeners"
    >
        <slot></slot>
    </isc-button>
</template>

<script>
export default {
    name: 'ButtonXlarge',

    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'default'
        },
        icon: {
            type: String,
            default: ''
        },
        plain: Boolean,
        width: {
            type: String,
            default: 'auto'
        }
    }
};
</script>

<style lang="scss" scoped>
.button-xlarge {
    height: 50px;
    line-height: normal;
    font-size: 16px;
}
</style>
